<div class="p-3">
  <div class="d-flex justify-content-between my-4 mx-3">
    <h5>POC Criteria - <span class="text-primary"> [{{payload?.proposal_name}}]</span></h5>
    <div class="d-flex gap-2">
      <!-- <p-button pTooltip="Generate PDF" icon="pi pi-file-pdf" (onClick)="generatePDF()" [outlined]="true"></p-button> -->
      <!-- <p-button pTooltip="Edit Form" icon="pi pi-pencil" (onClick)="editForm()" [outlined]="true"></p-button> -->
      <!-- <p-button label="Submit" icon="pi pi-save" (onClick)="saveChanges()" [outlined]="true"></p-button> -->
      <p-button label="Next" icon="pi pi-angle-right" iconPos="right" (onClick)="goToNextStep()"
        [outlined]="true" *ngIf="stepDetails?.step_status == 'approved'"></p-button>
      <p-button label="Initiate" icon="pi pi-play" *ngIf="stepDetails?.is_initiator" (onClick)="IRA.emit('Initiate')"
        [outlined]="true"></p-button>
      <p-button label="Approve" icon="pi pi-check-circle" *ngIf="stepDetails?.is_approver"
        (onClick)="IRA.emit('Approve')" [outlined]="true"></p-button>
      <p-button label="Recommend" icon="pi pi-thumbs-up" *ngIf="stepDetails?.is_recommender"
        (onClick)="IRA.emit('Recommend')" [outlined]="true"></p-button>

    </div>
  </div>
  <!-- <p-steps [model]="items" [readonly]="false" [activeIndex]="PDSactiveIndex"
    (activeIndexChange)="onPDSActiveIndexChange($event)" /> -->
  <hr>
  <!-- <ng-container *ngIf="PDSactiveIndex === 0">
    <div class="card p-3 mt-4 skip-stage-container">
      <div class="alert alert-warning mb-4">
        <i class="bi bi-exclamation-circle me-2"></i>
        <strong>Important</strong>
        <p class="mb-0 mt-1">Skipping criteria will mark all intermediate criteria as completed. This action cannot be
          undone.</p>
      </div>
      <div class="mb-4">
        <h6 class="mb-3">Select Target Criteria</h6>
        <div class="stages-list">
          <div class="form-check mb-3" *ngFor="let stage of stages; let i = index">
            <input class="form-check-input border-primary" type="checkbox" [id]="'stage' + i" name="targetStage"
              [value]="stage.id" [(ngModel)]="stage.exists_in_transaction">
            <label class="form-check-label" [for]="'stage' + i">
              <div class="d-flex flex-column">
                <span class="fw-medium">{{stage.name}}
                </span>
                <small class="text-muted-card">{{stage.sub_name}}</small>
              </div>
            </label>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-light" (click)="isSkipStep = false">Cancel</button>
        <button class="btn btn-primary" (click)="confirmSkipStage()">
          <i class="bi bi-skip-forward me-1"></i>
          Select Criteria
        </button>
      </div>
    </div>
  </ng-container> -->
  <!-- <ng-container *ngIf="PDSactiveIndex === 1"> -->
  <div class="d-flex justify-content-end mt-3 mb-3 gap-3">
    <!-- <p-button label="Submit" icon="pi pi-save" (onClick)="saveChanges()" [outlined]="true"></p-button> -->
    <button pButton label="Download PDF" icon="pi pi-download" printSectionId="print-section" ngxPrint
      class="fetch-data-btn"></button>
  </div>

  <div id="print-section">
    <div  class="table-wrap">
      <table class="table table-bordered">
        <thead>
          <tr class="bg-gray-100">
            <th rowspan="2">Sr No</th>
            <th rowspan="2">Evaluation Element</th>
            <th rowspan="2">Deliverables</th>
            <th rowspan="2">
              Total
              <!-- <button (click)="toggleEdit('total')" class="btn btn-sm btn-light">
          <i class="pi pi-pencil"></i>
        </button> -->
            </th>
            <th rowspan="2">
              Min Marks
              <!-- <button (click)="toggleEdit('minMarks')" class="btn btn-sm btn-light">
          <i class="pi pi-pencil"></i>
        </button> -->
            </th>
            <th *ngFor="let vendor of vendors;let i = index">
              {{ vendor.name }}
              <!-- <button (click)="toggleVendorEdit(vendor.id , i)" class="btn btn-sm btn-light">
                <i class="pi pi-pencil"></i>
              </button> -->
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of evaluationData; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ row.evaluationElement }}</td>
            <td>{{ row.deliverables }}</td>

            <td>
              <!-- <input *ngIf="editFields.total" type="number" [(ngModel)]="row.total_mark" class="form-control form-control-sm" /> -->
              <span *ngIf="!editFields.total">{{ row.total }}</span>
            </td>

            <td>
              <!-- <input *ngIf="editFields.minMarks" type="number" [(ngModel)]="row.cut_off" class="form-control form-control-sm" /> -->
              <span *ngIf="!editFields.minMarks">{{ row.minMarks }}</span>
            </td>

            <!-- <td *ngFor="let vendor of vendors">
        <input *ngIf="isVendorEditable[vendor.id]" type="number" [(ngModel)]="row.vendorMarks[vendor.id]" class="form-control form-control-sm" />
        <span *ngIf="!isVendorEditable[vendor.id]">{{ row.vendorMarks[vendor.id] }}</span>
      </td> -->
            <td *ngFor="let vendor of vendors; let vIdx = index">
              <div class="d-flex align-items-center">
                <input *ngIf="isVendorCellEditable[vendor.id]?.[i]" type="number"
                  [(ngModel)]="row.vendorMarks[vendor.id]" [max]="row.total"
                  class="form-control form-control-sm me-1" />

                <span *ngIf="!isVendorCellEditable[vendor.id]?.[i]">{{ row.vendorMarks[vendor.id] }}</span>

                <!-- ✅ Tick only during edit -->
                <button *ngIf="isVendorCellEditable[vendor.id]?.[i]" class="btn btn-sm btn-success"
                  (click)="logMark(row, vendor.id, i)"
                  [disabled]="row.vendorMarks[vendor.id] > row.total || row.vendorMarks[vendor.id] < 0">
                  <i class="pi pi-check"></i>
                </button>

                <!-- 🖊️ Edit icon per cell -->
                <button *ngIf="!isVendorCellEditable[vendor.id]?.[i]" class="btn btn-sm btn-light"
                  [disabled]="!(stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6))"
                  (click)="toggleVendorEdit(vendor.id, i)">
                  <i class="pi pi-pencil"></i>
                </button>
              </div>
            </td>


          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td colspan="3"><strong>Total</strong></td>
            <td><strong>{{ getTotalOverallMarks() }}</strong></td>
            <td><strong>{{ getTotalMinimumMarks() }}</strong></td>
            <td *ngFor="let vendor of vendors">
              <strong>{{ getTotalForVendor(vendor.id) }}</strong>
            </td>
          </tr>
          <tr>
            <td colspan="5"><strong>Qualification Status</strong></td>
            <td *ngFor="let vendor of vendors">
              <label>
                <input type="radio" name="qualification_{{vendor.id}}" value="Qualify"
                  [(ngModel)]="qualificationStatus[vendor.id] "
                  [disabled]="!(stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6))"
                  (change)="updateQualificationStatus(vendor, 'Qualify')" />
                Qualify
              </label>
              <br>
              <label>
                <input type="radio" name="qualification_{{vendor.id}}" value="Disqualify"
                  [(ngModel)]="qualificationStatus[vendor.id] "
                  [disabled]="!(stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6))"
                  (change)="updateQualificationStatus(vendor, 'Disqualify')" />
                Disqualify
              </label>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <!-- Signatures -->
   <div class="signatures-wrapper">
  <div class="signer-grid">
    <div class="signer-box" *ngFor="let signer of signers">
      <div class="signature-line">______________</div>
      <div class="signer-name">({{ capitalize(signer.user) }})</div>
      <div class="signer-role">{{ capitalize(signer.role) }}</div>
      <div class="signature-date">Date : ______________</div>
    </div>
  </div>
</div>


  </div>
  <!-- </ng-container> -->

</div>